module.exports = __webpack_public_path__ + "static/media/slideImgFive@2x.4ab55731.svg";